import { render, staticRenderFns } from "./MarketBankAccounts.vue?vue&type=template&id=3c7631f6&scoped=true"
import script from "./MarketBankAccounts.vue?vue&type=script&lang=js"
export * from "./MarketBankAccounts.vue?vue&type=script&lang=js"
import style0 from "./MarketBankAccounts.vue?vue&type=style&index=0&id=3c7631f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7631f6",
  null
  
)

export default component.exports